import styled, { css } from 'styled-components'
import { color, size, fontSize, fontWeight } from 'ui/themes/utils'

import Div from 'ui/elements/Div'
import Button from 'ui/elements/Button'

export const Backdrop = styled(Div)`
  position: fixed;

  display: flex;
  justify-content: center;

  top: 0;
  left: 0;

  width: 100vw;
  height: 100%;

  /* 99 = 0.6 opacity */
  background: ${color('Accent2/Controlvariant1')}99;

  opacity: ${({ state }) => (state === 'entered' ? 1 : 0)};

  padding: ${size('padding', 'lg')};

  font-family: ${(props) => props.theme.font.body};

  transition: 0.25s all;

  z-index: 10000000;

  box-sizing: border-box;
`

export const Body = styled(Div)`
  padding: ${size('padding', 'md')};

  @media screen and (max-height: 562px) {
    max-height: none;
  }
`

export const Header = styled(Div)`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  padding: ${size('padding', 'md')};

  &:empty {
    padding: 0;
  }
`

export const Footer = styled(Div)`
  display: flex;

  padding: ${size('padding', 'md')};

  background-color: ${color('white')};

  box-shadow: 0 -4px 10px 0 rgba(0, 0, 0, 0.18);

  z-index: 100;

  position: sticky;
  bottom: 0;
  left: 0;
  right: 0;
`

export const Container = styled(Div)`
  max-width: 825px;
  max-height: 100%;
  width: 100%;

  background: ${color('white')};

  box-shadow: 0 7px 10px 0 rgba(0, 0, 0, 0.18);

  border-radius: ${size('borderRadius')};

  margin: auto 0;

  opacity: 0;

  transform: translateY(15%);

  position: relative;

  ${({ state }) => state === 'entered' && css`
    opacity: 1;
    transform: translateY(0);
  `}

  overflow-y: auto;
  transition: all 0.25s ease;
`

export const Close = styled(Button)`
  appearance: none;

  background: transparent;

  border: none;

  position: absolute;

  top: ${size('padding', 'sm')};
  right: ${size('padding', 'sm')};

  opacity: 0.6;

  padding: 0;

  font-weight: ${fontWeight('bold')};
  font-size: ${fontSize('lg')};

  cursor: pointer;

  z-index: 99;

  transition: opacity 0.3s ease-in;

  &:hover, &:focus {
    opacity: 1;
  }
`
